import { C } from './constants.js';

// Shorthand aliases
const _ = C.BRICK_EMPTY;
const S = C.BRICK_STANDARD;
const H = C.BRICK_HARDENED;
const A = C.BRICK_ARMORED;
const T = C.BRICK_TNT;
const V = C.BRICK_VORTEX;
const P = C.BRICK_PRISM;
const R = C.BRICK_REGEN;
const I = C.BRICK_INDESTRUCTIBLE;
const F = C.BRICK_PHASE;

export const LEVELS = [
  // ==========================================
  // SECTOR 1: NEON GRID (Levels 1-1 to 1-5)
  // Theme: Cyan / Electric Blue
  // Uses: S, H, A, T, I
  // ==========================================

  // Level 1-1: Simple Intro Diamond
  {
    name: '1-1',
    sector: 1,
    grid: [
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, S, S, _, _, _, _],
      [_, _, _, S, S, S, S, _, _, _],
      [_, _, S, S, S, S, S, S, _, _],
      [_, S, S, S, _, _, S, S, S, _],
      [_, _, S, S, S, S, S, S, _, _],
      [_, _, _, S, S, S, S, _, _, _],
      [_, _, _, _, S, S, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // Level 1-2: Introduce Hardened Bricks (Chevron Wings)
  {
    name: '1-2',
    sector: 1,
    grid: [
      [_, _, _, _, _, _, _, _, _, _],
      [S, _, _, _, H, H, _, _, _, S],
      [S, S, _, H, S, S, H, _, S, S],
      [S, S, H, S, S, S, S, H, S, S],
      [_, S, H, S, H, H, S, H, S, _],
      [_, S, S, H, S, S, H, S, S, _],
      [_, _, S, S, S, S, S, S, _, _],
      [_, _, _, S, _, _, S, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // Level 1-3: Indestructible Walls & Armored Vault
  {
    name: '1-3',
    sector: 1,
    grid: [
      [S, S, _, _, _, _, _, _, S, S],
      [S, S, _, I, A, A, I, _, S, S],
      [S, H, _, I, A, A, I, _, H, S],
      [S, S, _, I, H, H, I, _, S, S],
      [_, S, _, I, _, _, I, _, S, _],
      [_, _, S, _, S, S, _, S, _, _],
      [_, _, S, S, H, H, S, S, _, _],
      [_, _, _, S, S, S, S, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // Level 1-4: TNT Gauntlet
  {
    name: '1-4',
    sector: 1,
    grid: [
      [S, S, H, S, T, T, S, H, S, S],
      [S, T, S, A, S, S, A, S, T, S],
      [H, S, S, S, H, H, S, S, S, H],
      [S, A, S, T, S, S, T, S, A, S],
      [T, S, H, S, A, A, S, H, S, T],
      [S, S, S, T, S, S, T, S, S, S],
      [_, H, S, S, H, H, S, S, H, _],
      [_, _, S, S, T, T, S, S, _, _],
      [_, _, _, S, S, S, S, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // Level 1-5: Sector 1 Boss
  {
    name: '1-5',
    sector: 1,
    boss: true,
    grid: [
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // ==========================================
  // SECTOR 2: CYBER DEPTHS (Levels 2-1 to 2-5)
  // Theme: Emerald / Cyber Green
  // Uses: S, H, V, F, A, I
  // ==========================================

  // Level 2-1: Introduce Vortex Bricks
  {
    name: '2-1',
    sector: 2,
    grid: [
      [_, _, S, S, S, S, S, S, _, _],
      [_, S, S, H, _, _, H, S, S, _],
      [S, S, _, _, V, V, _, _, S, S],
      [S, H, _, V, S, S, V, _, H, S],
      [S, _, _, S, V, V, S, _, _, S],
      [S, H, _, V, S, S, V, _, H, S],
      [S, S, _, _, V, V, _, _, S, S],
      [_, S, S, H, _, _, H, S, S, _],
      [_, _, S, S, S, S, S, S, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // Level 2-2: Phase Bricks Intro
  {
    name: '2-2',
    sector: 2,
    grid: [
      [F, F, F, F, F, F, F, F, F, F],
      [S, S, H, S, S, S, S, H, S, S],
      [F, _, F, _, F, F, _, F, _, F],
      [S, H, S, A, S, S, A, S, H, S],
      [F, F, F, F, _, _, F, F, F, F],
      [_, S, H, S, S, S, S, H, S, _],
      [_, F, _, F, F, F, F, _, F, _],
      [_, _, S, S, S, S, S, S, _, _],
      [_, _, _, F, _, _, F, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // Level 2-3: Vortex Maze
  {
    name: '2-3',
    sector: 2,
    grid: [
      [S, S, I, S, S, S, S, I, S, S],
      [S, V, I, H, S, S, H, I, V, S],
      [S, S, I, S, V, V, S, I, S, S],
      [_, _, I, S, S, S, S, I, _, _],
      [I, I, _, _, A, A, _, _, I, I],
      [S, S, _, I, V, V, I, _, S, S],
      [H, V, S, I, S, S, I, S, V, H],
      [S, S, S, _, _, _, _, S, S, S],
      [_, _, S, S, H, H, S, S, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // Level 2-4: Cyber Circuit Gauntlet
  {
    name: '2-4',
    sector: 2,
    grid: [
      [F, S, H, S, F, F, S, H, S, F],
      [S, V, A, S, H, H, S, A, V, S],
      [H, A, F, V, S, S, V, F, A, H],
      [S, S, V, A, F, F, A, V, S, S],
      [F, H, S, F, V, V, F, S, H, F],
      [S, A, F, S, H, H, S, F, A, S],
      [_, S, V, S, F, F, S, V, S, _],
      [_, _, H, A, S, S, A, H, _, _],
      [_, _, _, F, S, S, F, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // Level 2-5: Sector 2 Boss
  {
    name: '2-5',
    sector: 2,
    boss: true,
    grid: [
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // ==========================================
  // SECTOR 3: SOLAR FORGE (Levels 3-1 to 3-5)
  // Theme: Solar Orange / Fire
  // Uses: S, H, A, T, R, P
  // ==========================================

  // Level 3-1: Introduce Regen Bricks (Solar Blossom)
  {
    name: '3-1',
    sector: 3,
    grid: [
      [_, _, _, S, R, R, S, _, _, _],
      [_, S, S, H, S, S, H, S, S, _],
      [S, S, R, S, H, H, S, R, S, S],
      [S, H, S, S, R, R, S, S, H, S],
      [R, S, H, R, S, S, R, H, S, R],
      [S, H, S, S, R, R, S, S, H, S],
      [S, S, R, S, H, H, S, R, S, S],
      [_, S, S, H, S, S, H, S, S, _],
      [_, _, _, S, R, R, S, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // Level 3-2: Prism Introduction (Prism Pyramids)
  {
    name: '3-2',
    sector: 3,
    grid: [
      [S, S, H, S, P, P, S, H, S, S],
      [S, P, S, S, H, H, S, S, P, S],
      [H, S, S, A, S, S, A, S, S, H],
      [S, S, A, S, P, P, S, A, S, S],
      [P, H, S, S, S, S, S, S, H, P],
      [S, S, H, P, S, S, P, H, S, S],
      [_, S, S, S, H, H, S, S, S, _],
      [_, _, S, S, P, P, S, S, _, _],
      [_, _, _, S, S, S, S, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // Level 3-3: Chain Reaction Puzzle
  {
    name: '3-3',
    sector: 3,
    grid: [
      [T, S, R, T, S, S, T, R, S, T],
      [S, T, H, R, T, T, R, H, T, S],
      [R, H, T, S, R, R, S, T, H, R],
      [T, R, S, T, H, H, T, S, R, T],
      [S, T, R, H, T, T, H, R, T, S],
      [T, H, T, R, S, S, R, T, H, T],
      [_, R, S, T, P, P, T, S, R, _],
      [_, _, T, H, R, R, H, T, _, _],
      [_, _, _, T, S, S, T, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // Level 3-4: Solar Forge Gauntlet
  {
    name: '3-4',
    sector: 3,
    grid: [
      [A, H, T, S, P, P, S, T, H, A],
      [H, A, S, R, T, T, R, S, A, H],
      [T, S, A, H, R, R, H, A, S, T],
      [S, R, H, P, A, A, P, H, R, S],
      [P, T, R, A, T, T, A, R, T, P],
      [S, R, H, P, A, A, P, H, R, S],
      [T, S, A, H, R, R, H, A, S, T],
      [_, H, S, R, T, T, R, S, H, _],
      [_, _, H, T, P, P, T, H, _, _],
      [_, _, _, S, S, S, S, _, _, _],
    ]
  },

  // Level 3-5: Sector 3 Boss
  {
    name: '3-5',
    sector: 3,
    boss: true,
    grid: [
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },

  // ==========================================
  // SECTOR 4: VOID NEXUS (Levels 4-1 to 4-5)
  // Theme: Cosmic Violet / Deep Purple
  // Uses: ALL brick types (S, H, A, T, V, P, R, I, F)
  // ==========================================

  // Level 4-1: Mixed Challenge Mandala
  {
    name: '4-1',
    sector: 4,
    grid: [
      [I, S, F, H, P, P, H, F, S, I],
      [S, V, A, T, S, S, T, A, V, S],
      [F, A, R, V, H, H, V, R, A, F],
      [H, T, V, P, F, F, P, V, T, H],
      [P, S, H, F, I, I, F, H, S, P],
      [P, S, H, F, I, I, F, H, S, P],
      [H, T, V, P, F, F, P, V, T, H],
      [F, A, R, V, H, H, V, R, A, F],
      [S, V, A, T, S, S, T, A, V, S],
      [_, _, _, S, P, P, S, _, _, _],
    ]
  },

  // Level 4-2: Phase & Vortex Labyrinth
  {
    name: '4-2',
    sector: 4,
    grid: [
      [F, F, S, V, H, H, V, S, F, F],
      [F, V, H, F, S, S, F, H, V, F],
      [S, H, F, A, V, V, A, F, H, S],
      [V, F, A, S, F, F, S, A, F, V],
      [H, S, V, F, P, P, F, V, S, H],
      [H, S, V, F, P, P, F, V, S, H],
      [V, F, A, S, F, F, S, A, F, V],
      [S, H, F, A, V, V, A, F, H, S],
      [F, V, H, F, S, S, F, H, V, F],
      [_, F, S, _, _, _, _, S, F, _],
    ]
  },

  // Level 4-3: The Void Fortress
  {
    name: '4-3',
    sector: 4,
    grid: [
      [I, A, A, I, S, S, I, A, A, I],
      [I, R, R, I, T, T, I, R, R, I],
      [I, A, A, I, P, P, I, A, A, I],
      [S, H, S, _, A, A, _, S, H, S],
      [I, I, _, V, R, R, V, _, I, I],
      [A, T, F, I, H, H, I, F, T, A],
      [A, R, F, I, P, P, I, F, R, A],
      [I, I, _, _, A, A, _, _, I, I],
      [_, S, H, S, T, T, S, H, S, _],
      [_, _, S, S, S, S, S, S, _, _],
    ]
  },

  // Level 4-4: Ultimate Void Gauntlet
  {
    name: '4-4',
    sector: 4,
    grid: [
      [A, T, H, F, P, P, F, H, T, A],
      [T, I, R, A, V, V, A, R, I, T],
      [H, R, A, T, F, F, T, A, R, H],
      [F, A, T, P, I, I, P, T, A, F],
      [P, V, F, I, R, R, I, F, V, P],
      [P, V, F, I, R, R, I, F, V, P],
      [F, A, T, P, I, I, P, T, A, F],
      [H, R, A, T, F, F, T, A, R, H],
      [T, I, R, A, V, V, A, R, I, T],
      [S, S, H, F, P, P, F, H, S, S],
    ]
  },

  // Level 4-5: Final Boss - The Void Core
  {
    name: '4-5',
    sector: 4,
    boss: true,
    grid: [
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
      [_, _, _, _, _, _, _, _, _, _],
    ]
  },
];
